import { getForm } from 'remote-com-shared/domains/hubspot/services';

import { getSlicesContext } from '@/src/domains/prismic/helpers';
import { querySharedServices } from '@/src/domains/shared/services';
import { querySwitchToRemotePage } from '@/src/views/SwitchToRemote/services';

export { SwitchToRemotePage as default } from '@/src/views/SwitchToRemote';

export async function getStaticProps({ previewData, locale }) {
  const dataContent = await querySwitchToRemotePage({ previewData, locale });
  const sharedServices = await querySharedServices({ previewData, locale });

  if (!dataContent) {
    return { notFound: true };
  }

  const { tone } = dataContent;

  const heroData = dataContent?.body?.find(({ slice_type: type }) => type === 'hero_section');

  const {
    hubspot_form_id: formId,
    hero_form_title: formTitle,
    hero_form_description: formDescription,
    hero_form_button_label: formButtonLabel,
  } = heroData?.primary;

  const { data: hubspotFormDefinition } = await getForm(formId);
  const body = await getSlicesContext(dataContent.body, {
    hero_section: async () => ({
      hubspotFormDefinition,
      formTitle,
      formDescription,
      formButtonLabel,
      tone,
    }),

    overview_section: async () => ({
      tone,
    }),
    integration_slice: async () => ({
      tone,
    }),
    cta_with_logos: async () => ({
      tone,
    }),
    bottom_cta: async () => ({
      tone,
    }),
  });

  return {
    props: {
      ...dataContent,
      sharedServices,
      body,
    },
  };
}
